import { getImagesSizes } from '~/utils/image-sizes-utils';
import type { LoadingValue } from '@archipro-design/aria';
import type { TileCarouselImage } from '@modules/products-category/util/product-tile-view-model.server';

export const DIRECTORY_IMAGE_WIDTH_DESKTOP_THIRDS = 595;
export const DIRECTORY_IMAGE_WIDTH_DESKTOP_QUARTER = 348;
export const DIRECTORY_IMAGE_WIDTH_MOBILE_THIRDS = 414;
export const DIRECTORY_IMAGE_WIDTH_MOBILE_QUARTER = 204;

export const getDirectoryTileImageProps = (
    tileIndex: number,
    perRowMobile: number,
    perRowDesktop: number,
    isMobile: boolean,
    imageUrls: string[] | TileCarouselImage[],
    alt?: string
) => {
    return imageUrls.map((image) => {
        const loading: LoadingValue = 'lazy';
        const desktopTileSize =
            perRowDesktop > 3
                ? DIRECTORY_IMAGE_WIDTH_DESKTOP_QUARTER
                : DIRECTORY_IMAGE_WIDTH_DESKTOP_THIRDS;
        const mobileTileSize =
            perRowMobile > 1
                ? DIRECTORY_IMAGE_WIDTH_MOBILE_QUARTER
                : DIRECTORY_IMAGE_WIDTH_MOBILE_THIRDS;

        return {
            src: typeof image === 'object' ? image.src : image,
            mixBlendMode:
                typeof image === 'object' ? image.mixBlendMode : 'normal',
            width: '100%',
            height: '100%',
            sizes: getImagesSizes({
                desktop: desktopTileSize,
                mobile: mobileTileSize,
            }),
            alt: alt || '',
            loading: loading,
        };
    });
};
